(() => {
  const gallerySelector = '.card-gallery[on\\:pointerenter="/previewImage"]';
  const desktopHover = window.matchMedia('(hover: hover) and (min-width: 990px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const states = new WeakMap();

  const activeImage = (gallery) =>
    gallery.querySelector('slideshow-slide[aria-hidden="false"] img.product-media__image');

  const cloneImage = (image, modifier) => {
    if (!(image instanceof HTMLImageElement)) return null;

    const clone = image.cloneNode(false);
    clone.removeAttribute('id');
    clone.removeAttribute('fetchpriority');
    clone.loading = 'eager';
    if (image.currentSrc) {
      clone.removeAttribute('sizes');
      clone.removeAttribute('srcset');
      clone.src = image.currentSrc;
    }
    clone.className = `ig-product-card-crossfade ig-product-card-crossfade--${modifier}`;
    clone.alt = '';
    clone.setAttribute('aria-hidden', 'true');
    return clone;
  };

  const rememberBaseImage = (gallery) => {
    const base = cloneImage(activeImage(gallery), 'base');
    if (!base) return;

    const state = states.get(gallery) || { token: 0 };
    state.base = base;
    states.set(gallery, state);
  };

  const nextImage = (gallery, base) => {
    const images = [...gallery.querySelectorAll('slideshow-slide img.product-media__image')];
    if (images.length < 2) return null;

    const baseSource = base.currentSrc || base.src;
    const currentIndex = images.findIndex((image) => (image.currentSrc || image.src) === baseSource);
    return images[(currentIndex >= 0 ? currentIndex + 1 : 1) % images.length];
  };

  const clearLayers = (state) => {
    state.cover?.remove();
    state.preview?.remove();
    state.cover = null;
    state.preview = null;
  };

  const transitionIn = (gallery) => {
    if (!desktopHover.matches || reducedMotion.matches) return;

    if (!states.has(gallery)) rememberBaseImage(gallery);
    const state = states.get(gallery);
    if (!state?.base) return;

    state.token += 1;
    const token = state.token;
    clearLayers(state);

    state.cover = state.base.cloneNode(false);
    gallery.append(state.cover);

    requestAnimationFrame(() => {
      if (state.token !== token) return;

      const current = activeImage(gallery);
      const currentSource = current?.currentSrc || current?.src;
      const baseSource = state.base.currentSrc || state.base.src;
      const source = currentSource && currentSource !== baseSource ? current : nextImage(gallery, state.base);
      state.preview = cloneImage(source, 'preview');
      if (!state.preview) {
        clearLayers(state);
        return;
      }

      state.preview.style.opacity = '0';
      gallery.append(state.preview);

      const startFade = () => {
        if (state.token !== token || !state.preview) return;
        const animation = state.preview.animate([{ opacity: 0 }, { opacity: 1 }], {
          duration: 350,
          easing: 'ease',
          fill: 'forwards',
        });
        animation.onfinish = () => {
          if (state.token !== token || !state.preview) return;
          state.preview.style.opacity = '1';
          state.cover?.remove();
          state.cover = null;
        };
      };

      if (state.preview.complete) startFade();
      else state.preview.addEventListener('load', startFade, { once: true });
    });
  };

  const transitionOut = (gallery) => {
    const state = states.get(gallery);
    if (!state) return;

    state.token += 1;
    state.cover?.remove();
    state.cover = null;

    if (state.preview && !reducedMotion.matches) {
      const preview = state.preview;
      const currentOpacity = Number.parseFloat(getComputedStyle(preview).opacity);
      const animation = preview.animate([{ opacity: currentOpacity }, { opacity: 0 }], {
        duration: 350,
        easing: 'ease',
        fill: 'forwards',
      });
      animation.onfinish = () => preview.remove();
      animation.oncancel = () => preview.remove();
      state.preview = null;
    } else {
      state.preview?.remove();
      state.preview = null;
    }

    requestAnimationFrame(() => rememberBaseImage(gallery));
  };

  document.addEventListener(
    'pointerover',
    (event) => {
      const gallery = event.target instanceof Element ? event.target.closest(gallerySelector) : null;
      if (gallery instanceof HTMLElement && !states.has(gallery)) rememberBaseImage(gallery);
    },
    true
  );

  document.addEventListener(
    'pointerenter',
    (event) => {
      const gallery = event.target instanceof Element ? event.target.closest(gallerySelector) : null;
      if (gallery instanceof HTMLElement && event.target === gallery) transitionIn(gallery);
    },
    true
  );

  document.addEventListener(
    'pointerleave',
    (event) => {
      const gallery = event.target instanceof Element ? event.target.closest(gallerySelector) : null;
      if (gallery instanceof HTMLElement && event.target === gallery) transitionOut(gallery);
    },
    true
  );
})();
